import { type FigmaExporter, FigmaExporterAnyDesignNodeSchema } from "@supernova-studio/model";
import { z } from "zod";

export const DTOFigmaNodeResponse: z.ZodType<{
  nodes: FigmaExporter["AnyDesignNode"];
}> = z.object({
  nodes: FigmaExporterAnyDesignNodeSchema,
});

export type DTOFigmaNodeResponse = {
  nodes: FigmaExporter["AnyDesignNode"];
};
